import Vue from 'vue';
import moment from 'moment';
import fileDownload from 'js-file-download';
import VCard from '@/services/VCard';

export default null;

export const state = {
  title: 'VCardConverter',
  user: null,
  contacts: null,
  messages: [],
};

export const getters = {
  get isLoggedin() {
    return state.user !== null;
  },

  get hasMonthPlan() {
    return this.isLoggedin && state.user.plan === 'month';
  },

  get hasLifetimePlan() {
    return this.isLoggedin && state.user.plan === 'lifetime';
  },

  get hasPaidMonth() {
    return this.hasMonthPlan && state.user.paymentAt !== false;
  },

  get hasPaidLifetime() {
    return this.hasLifetimePlan && state.user.paymentAt !== false;
  },

  get hasAPaidPlanButNotPaid() {
    return (
      (this.hasMonthPlan && !this.hasPaidMonth)
      || (this.hasLifetimePlan && !this.hasPaidLifetime)
    );
  },

  get monthPlanExpireDate() {
    if (this.hasPaidMonth) {
      return moment(state.user.paymentAt).add(29, 'days').format('ll');
    }

    return -1;
  },

  get monthPLanDaysLeft() {
    if (this.hasPaidMonth) {
      return 29 - moment()
        .diff(moment(state.user.paymentAt), 'days');
    }

    return false;
  },

  get canDownloadFull() {
    return (
      (this.hasMonthPlan && this.hasPaidMonth && this.monthPLanDaysLeft >= 0)
      || (this.hasLifetimePlan && this.hasPaidLifetime)
    );
  },

  get canOnlyFreeDownload() {
    return (
      !this.isLoggedin
      || (
        this.isLoggedin
        && (
          state.user.plan === 'free'
          || this.hasAPaidPlanButNotPaid
          || (this.hasMonthPlan && this.hasPaidMonth && this.monthPLanDaysLeft < 0)
        )
      )
    );
  },
};

export const mapGetters = () => Object.keys(getters)
  .reduce((acc, curr) => {
    acc[curr] = () => getters[curr];
    return acc;
  }, {});

export const setState = (key, value) => {
  state[key] = value;
};

const cleanUserDate = (data) => {
  if (!data) {
    return data;
  }

  if (!['free', 'month', 'lifetime'].includes(data.plan)) {
    data.plan = 'free';
  }

  return data;
};

export const setUser = (user) => {
  state.user = cleanUserDate(user);
};

export const updateUser = (data) => {
  if (!getters.isLoggedin) {
    return;
  }

  cleanUserDate(data);

  state.user = {
    ...state.user,
    ...data,
  };
};

export const downloadContacts = (type = 'outlook', onlyFree = false) => {
  if (!state.contacts) {
    return;
  }

  let freeDownload = '';
  let fullDownload = '';
  const convertToVCard = (
    type === 'outlook' ? VCard.convertFromOutlook : VCard.convertFromGmail
  ).bind(VCard);

  state.contacts.forEach((one, i) => {
    if (i < 10) {
      freeDownload += convertToVCard(one);
    }

    fullDownload += convertToVCard(one);
  });

  fileDownload(onlyFree ? freeDownload : fullDownload, 'vcard_converter.vcf');
  state.contacts = null;
};

export const removeMessage = ({ id, timer }) => {
  state.messages = state.messages.filter((m) => m.id !== id);
  clearInterval(timer);
};
export const addMessage = (text, type = 'info', timeout = 3000) => {
  const message = {
    id: Math.random().toFixed(16),
    timer: null,
    type,
    text,
  };
  state.messages.push(message);
  message.timer = setTimeout(() => removeMessage(message), timeout);
};

Vue.prototype.$addMessage = addMessage;
window.$addMessage = addMessage;
